import { notifications } from '@mantine/notifications';
import { saveAs } from 'file-saver';
import { auth } from '../firebase';

interface RequesterParams {
    headers?: Record<string, any>;
    baseUrl?: string;
    port?: string;
    path: string;
    payload?: any;
    method: string;
    searchParams?: string;
    blockContentType?: boolean;
    isFileDownload?: boolean;
    pageData?: {
        index: number;
        size: number;
    };
}

export const Requester = async <ResponseType>({
    headers = {},
    baseUrl,
    port,
    path,
    payload,
    searchParams,
    pageData,
    isFileDownload,
    method,
    blockContentType
}: RequesterParams): Promise<ResponseType | {}> => {
    const FirebaseUserAuthToken = (await auth?.currentUser?.getIdToken()) || false;
    const requestHeaders: HeadersInit = new Headers();

    Object.entries(headers).forEach(([key, value]) => {
        requestHeaders.set(key, value);
    });

    if (FirebaseUserAuthToken) {
        requestHeaders.set('Authorization', `Bearer ${FirebaseUserAuthToken}`);
    }

    // if (import.meta.env.NODE_ENV === 'development' && import.meta.env.CF_Auth) {
    //     requestHeaders.set('Cf-Access-Jwt-Assertion', import.meta.env.CF_Auth);
    // }

    if (!blockContentType) {
        requestHeaders.set('Content-Type', method === 'GET' ? 'application/x-www-form-urlencoded' : 'application/json');
    }

    try {
        if (!path) throw new Error('No api endpoint specified');
        const response = await fetch(
            `${baseUrl || import.meta.env.VITE_API_BASE_PATH}${port ? `:${port}` : ``}/${path}${
                searchParams ? `?${searchParams}` : ''
            }`,
            {
                headers: requestHeaders,
                body: blockContentType ? payload : JSON.stringify(payload),
                method
            }
        );

        if (response.status === 204) {
            return Promise.resolve({});
        }

        if (isFileDownload) {
            if (!response.ok) {
                const responseBody = await response.json().catch(() => null);
                if (responseBody?.showMessage && responseBody?.message) {
                    notifications.show({
                        color: 'red',
                        title: responseBody?.status ?? '',
                        message: responseBody.message
                    });
                }

                return Promise.reject({ error: responseBody, statusCode: response.status });
            } else {
                if (response !== null && response !== undefined) {
                    const filename =
                        response.headers
                            ?.get('content-disposition')
                            ?.split(';')
                            ?.find((n: string) => n.includes('filename='))
                            ?.replace('filename=', '')
                            .trim() ?? 'BEEP_Export_Filename_Missing';
                    const blob = await response.blob();

                    // Download the file
                    saveAs(blob, `${filename}.zip`);
                }
            }

            return Promise.resolve({});
        } else {
            const responseBody = await response.json().catch(() => null);
            if (!response.ok) {
                if (responseBody?.showMessage && responseBody?.message) {
                    notifications.show({
                        color: 'red',
                        title: responseBody?.status ?? '',
                        message: responseBody.message
                    });
                }

                return Promise.reject({ error: responseBody, statusCode: response.status });
            }

            return Promise.resolve({ ...responseBody });
        }
    } catch (e) {
        console.error(e);
        return Promise.reject(e);
    }
};
